import { DateCustom } from "frontend-core";
import { IUserDTO, User } from "@/models/User";

export class AgentOsagoBlockInfo {
    status: boolean;
    changedDate: DateCustom | null;
    changedUser: User | null;

    constructor(obj: IOsagoBlockInfoDTO) {
        this.status = obj.status;
        this.changedUser = obj.changedUser !== null ? new User(obj.changedUser) : null;
        this.changedDate = obj.changedDate !== null ? new DateCustom(obj.changedDate) : null;
    }
}

export type IOsagoBlockInfoDTO = Readonly<{
    "changedDate": string | null;
    "changedUser": IUserDTO | null;
    "oldValue": boolean | null;
    // false - можно оформлять, true - оформление заблокировано
    "status": boolean;
}>
